// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__wGbtD","footer":"NavbarSimple_footer__doAwf","link":"NavbarSimple_link__hF-Zs","linkIcon":"NavbarSimple_linkIcon__8eKaS"};